
import React from 'react';
import { Button } from '@/components/ui/button';
import { BrandText, BrandGradient } from '@/components/ui/brand';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import featureFlags from '@/lib/featureFlags';

const CTASection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (featureFlags.enableSignup) {
      navigate('/onboarding');
    } else {
      // Scroll to beta section
      const betaElement = document.getElementById('whitelist-section');
      if (betaElement) {
        betaElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className="relative py-16 overflow-hidden bg-brand">
      <div className="container mx-auto px-6 text-center relative z-10">
        <div className="max-w-2xl mx-auto">
          <BrandText as="h2" size="3xl" weight="bold" className="mb-4 text-white">
            Ready to transform your business?
          </BrandText>
          <BrandText className="text-white/90 mb-8">
            Join businesses using VirtuStaff.ai to save time and automate routine tasks.
          </BrandText>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button 
              size="lg" 
              onClick={handleGetStarted}
              className="bg-white text-brand hover:bg-gray-light rounded-xl font-semibold"
            >
              {featureFlags.enableSignup ? 'Get Started Today' : 'Join Our Beta'} <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="bg-transparent border-white text-white hover:bg-white/10 rounded-xl"
              onClick={() => navigate('/support', { state: { from: 'landing' } })}
            >
              Need Help?
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
